module.exports = __webpack_public_path__ + "img/comic_digital_person2.fa09e099.jpg";